import { css } from 'styled-components';

export const tokens = css`
:root {
  --aui-border-radius-100: 0.5rem;
  --aui-border-radius-200: 1rem;
  --aui-border-radius-300: 1.5rem;
  --aui-border-radius-400: 2rem;
  --aui-border-radius-none: 0rem;
  --aui-border-radius-round: 10000rem;
  --aui-border-radius-025: 0.125rem;
  --aui-border-radius-050: 0.25rem;
  --aui-breakpoints-xs: 20rem;
  --aui-breakpoints-sm: 23.4375rem;
  --aui-breakpoints-md: 48rem;
  --aui-breakpoints-lg: 64rem;
  --aui-breakpoints-xl: 80rem;
  --aui-breakpoints-xxl: 90rem;
  --aui-opacity-10: 10%;
  --aui-opacity-12: 12%;
  --aui-opacity-20: 20%;
  --aui-opacity-30: 30%;
  --aui-opacity-40: 40%;
  --aui-opacity-50: 50%;
  --aui-opacity-60: 60%;
  --aui-opacity-70: 70%;
  --aui-opacity-75: 75%;
  --aui-opacity-80: 80%;
  --aui-opacity-90: 90%;
  --aui-opacity-100: 100%;
  --aui-opacity-none: 0%;
  --aui-opacity-04: 4%;
  --aui-opacity-08: 8%;
  --aui-spacing-100: 0.5rem;
  --aui-spacing-150: 0.75rem;
  --aui-spacing-200: 1rem;
  --aui-spacing-300: 1.5rem;
  --aui-spacing-400: 2rem;
  --aui-spacing-500: 2.5rem;
  --aui-spacing-600: 3rem;
  --aui-spacing-800: 4rem;
  --aui-spacing-1000: 5rem;
  --aui-spacing-1200: 6rem;
  --aui-spacing-000: 0rem;
  --aui-spacing-025: 0.125rem;
  --aui-spacing-050: 0.25rem;
  --aui-spacing-075: 0.375rem;
  --aui-state-layer-none: 0%;
  --aui-state-layer-hover: 8%;
  --aui-state-layer-press: 12%;
  --aui-state-layer-disabled: 12%;
  --aui-state-layer-on-disabled: 30%;
  --aui-state-layer-read-only: 8%;
  --aui-state-layer-on-read-only: 70%;
  --aui-state-layer-press-card: 4%;
  --aui-stroke-card: 0.0625rem;
  --aui-stroke-selected-card-hover: 0.125rem;
  --aui-stroke-divider: 0.0625rem;
}

.asurion-dark {
  --aui-brand-white: #ffffff;
  --aui-brand-black: #0c0e11;
  --aui-brand-asurion-purple: #8223d2;
  --aui-brand-asurion-yellow: #d2fa46;
  --aui-brand-asurion-blue: #4a68f9;
  --aui-brand-asurion-green: #6efac3;
  --aui-sub-surface: #040308;
  --aui-surface: #130f17;
  --aui-surface-variant: #1e1a22;
  --aui-on-surface: #f8eef9;
  --aui-on-surface-soft: #cdc4ce;
  --aui-outline: #7c757e;
  --aui-outline-soft: #4a454e;
  --aui-scrim-overlay: #0c0e1180;
  --aui-elevated-level-01: #221e26;
  --aui-elevated-level-02: #29242c;
  --aui-elevated-level-03: #2d2830;
  --aui-elevated-dynamic-card: #edddf60a;
  --aui-primary: #ddb7ff;
  --aui-on-primary: #1c0334;
  --aui-primary-soft: #410071;
  --aui-on-primary-soft: #ddb7ff;
  --aui-secondary: #4e4356;
  --aui-on-secondary: #edddf6;
  --aui-neutral: #f8eef9;
  --aui-on-neutral: #130f17;
  --aui-neutral-soft: #4a454e;
  --aui-on-neutral-soft: #e9dfeb;
  --aui-inverse-surface: #e9dfeb;
  --aui-inverse-on-surface: #130f17;
  --aui-inverse-primary: #8223d2;
  --aui-status-success-soft: #0b4521;
  --aui-status-on-success-soft: #c5ffc8;
  --aui-status-success: #47e26f;
  --aui-status-on-success: #0a2415;
  --aui-status-error-soft: #7d000f;
  --aui-status-on-error-soft: #ffeae9;
  --aui-status-error: #ffb3ad;
  --aui-status-on-error: #470306;
  --aui-status-warning-soft: #e7c500;
  --aui-status-on-warning-soft: #3a3000;
  --aui-status-warning: #ffe264;
  --aui-status-on-warning: #221b00;
  --aui-accent-red: #ffb2b9;
  --aui-accent-on-red: #40000f;
  --aui-accent-red-soft: #7c0026;
  --aui-accent-on-red-soft: #ffeced;
  --aui-accent-orange: #ffb690;
  --aui-accent-on-orange: #341100;
  --aui-accent-orange-soft: #632700;
  --aui-accent-on-orange-soft: #ffede6;
  --aui-accent-tennis: #dcff66;
  --aui-accent-on-tennis: #171e00;
  --aui-accent-tennis-soft: #334000;
  --aui-accent-on-tennis-soft: #dcff66;
  --aui-accent-green: #65f2bc;
  --aui-accent-on-green: #002115;
  --aui-accent-green-soft: #004530;
  --aui-accent-on-green-soft: #bdffdf;
  --aui-accent-teal: #2fd9f4;
  --aui-accent-on-teal: #001f25;
  --aui-accent-teal-soft: #00424c;
  --aui-accent-on-teal-soft: #d4f7ff;
  --aui-accent-blue: #bac3ff;
  --aui-accent-on-blue: #001159;
  --aui-accent-blue-soft: #061e77;
  --aui-accent-on-blue-soft: #f0efff;
  --aui-accent-purple: #ddb7ff;
  --aui-accent-on-purple: #1c0334;
  --aui-accent-purple-soft: #410071;
  --aui-accent-on-purple-soft: #ddb7ff;
  --aui-fills-surface-contrast: #f8eef90a;
  --aui-fills-surface-contrast-inverse: #130f1714;
  --aui-fills-drop-shadow: #160d1e26;
  --aui-fills-actions-pressed-shadow: #ffffff14;
  --aui-fills-cards-pressed-shadow: #0c0e110a;
  --aui-fills-sticker-opacity: 100%;
  --aui-gradient-dark-stop-1: #ca93ff;
  --aui-gradient-dark-stop-2: #f2aeff;
  --aui-gradient-light-stop-1: #370f5b;
  --aui-gradient-light-stop-2: #001a42;
}

:root, .asurion-light {
  --aui-brand-white: #ffffff;
  --aui-brand-black: #0c0e11;
  --aui-brand-asurion-purple: #8223d2;
  --aui-brand-asurion-yellow: #d2fa46;
  --aui-brand-asurion-blue: #4a68f9;
  --aui-brand-asurion-green: #6efac3;
  --aui-sub-surface: #f1f0f4;
  --aui-surface: #ffffff;
  --aui-surface-variant: #faf9fc;
  --aui-on-surface: #1a1c1e;
  --aui-on-surface-soft: #5d5e61;
  --aui-outline: #c6c6ca;
  --aui-outline-soft: #eeedf1;
  --aui-scrim-overlay: #0c0e1180;
  --aui-elevated-level-01: #ffffff;
  --aui-elevated-level-02: #ffffff;
  --aui-elevated-level-03: #ffffff;
  --aui-elevated-dynamic-card: #ffffff;
  --aui-primary: #8223d2;
  --aui-on-primary: #ffffff;
  --aui-primary-soft: #faecff;
  --aui-on-primary-soft: #590099;
  --aui-secondary: #edddf6;
  --aui-on-secondary: #211829;
  --aui-neutral: #1a1c1e;
  --aui-on-neutral: #ffffff;
  --aui-neutral-soft: #f1f0f4;
  --aui-on-neutral-soft: #2f3033;
  --aui-inverse-surface: #252629;
  --aui-inverse-on-surface: #ffffff;
  --aui-inverse-primary: #ca93ff;
  --aui-status-success-soft: #c5ffc8;
  --aui-status-on-success-soft: #062011;
  --aui-status-success: #136d31;
  --aui-status-on-success: #c5ffc8;
  --aui-status-error-soft: #ffdad7;
  --aui-status-on-error-soft: #410004;
  --aui-status-error: #b91a24;
  --aui-status-on-error: #ffeae9;
  --aui-status-warning-soft: #fff0c0;
  --aui-status-on-warning-soft: #3a3000;
  --aui-status-warning: #e7c500;
  --aui-status-on-warning: #524609;
  --aui-accent-red: #b91641;
  --aui-accent-on-red: #fff8f7;
  --aui-accent-red-soft: #ffe1e2;
  --aui-accent-on-red-soft: #67001e;
  --aui-accent-orange: #ec6a06;
  --aui-accent-on-orange: #fff8f6;
  --aui-accent-orange-soft: #ffe2d5;
  --aui-accent-on-orange-soft: #552100;
  --aui-accent-tennis: #d2fa46;
  --aui-accent-on-tennis: #171e00;
  --aui-accent-tennis-soft: #e5ff8d;
  --aui-accent-on-tennis-soft: #293500;
  --aui-accent-green: #6efac3;
  --aui-accent-on-green: #002115;
  --aui-accent-green-soft: #ccffe5;
  --aui-accent-on-green-soft: #003826;
  --aui-accent-teal: #2fd9f4;
  --aui-accent-on-teal: #001f25;
  --aui-accent-teal-soft: #ddf9ff;
  --aui-accent-on-teal-soft: #00363e;
  --aui-accent-blue: #4a68f9;
  --aui-accent-on-blue: #fbf8ff;
  --aui-accent-blue-soft: #f4f2ff;
  --aui-accent-on-blue-soft: #00208d;
  --aui-accent-purple: #8223d2;
  --aui-accent-on-purple: #ffffff;
  --aui-accent-purple-soft: #faecff;
  --aui-accent-on-purple-soft: #590099;
  --aui-fills-surface-contrast: #0c0e110a;
  --aui-fills-surface-contrast-inverse: #ffffff14;
  --aui-fills-drop-shadow: #0c0e110a;
  --aui-fills-actions-pressed-shadow: #0c0e1114;
  --aui-fills-cards-pressed-shadow: #0c0e110a;
  --aui-fills-sticker-opacity: 0%;
  --aui-gradient-dark-stop-1: #6900b3;
  --aui-gradient-dark-stop-2: #991bbd;
  --aui-gradient-light-stop-1: #faecff;
  --aui-gradient-light-stop-2: #effcff;
}

.partner-dark {
  --aui-brand-white: #ffffff;
  --aui-brand-black: #0c0e11;
  --aui-brand-asurion-purple: #8223d2;
  --aui-brand-asurion-yellow: #d2fa46;
  --aui-brand-asurion-blue: #4a68f9;
  --aui-brand-asurion-green: #6efac3;
  --aui-sub-surface: #030405;
  --aui-surface: #0f1114;
  --aui-surface-variant: #1a1c1e;
  --aui-on-surface: #f1f0f4;
  --aui-on-surface-soft: #c6c6ca;
  --aui-outline: #76777a;
  --aui-outline-soft: #46474a;
  --aui-scrim-overlay: #0c0e1180;
  --aui-elevated-level-01: #1e2022;
  --aui-elevated-level-02: #252629;
  --aui-elevated-level-03: #292a2d;
  --aui-elevated-dynamic-card: #e3e2e60a;
  --aui-primary: #ffffff;
  --aui-on-primary: #0f1114;
  --aui-primary-soft: #292a2d;
  --aui-on-primary-soft: #ffffff;
  --aui-secondary: #46474a;
  --aui-on-secondary: #e3e2e6;
  --aui-neutral: #f1f0f4;
  --aui-on-neutral: #0f1114;
  --aui-neutral-soft: #46474a;
  --aui-on-neutral-soft: #e3e2e6;
  --aui-inverse-surface: #e3e2e6;
  --aui-inverse-on-surface: #0f1114;
  --aui-inverse-primary: #46474a;
  --aui-status-success-soft: #0b4521;
  --aui-status-on-success-soft: #c5ffc8;
  --aui-status-success: #47e26f;
  --aui-status-on-success: #0a2415;
  --aui-status-error-soft: #7d000f;
  --aui-status-on-error-soft: #ffeae9;
  --aui-status-error: #ffb3ad;
  --aui-status-on-error: #470306;
  --aui-status-warning-soft: #e7c500;
  --aui-status-on-warning-soft: #3a3000;
  --aui-status-warning: #ffe264;
  --aui-status-on-warning: #221b00;
  --aui-accent-red: #ffb2b9;
  --aui-accent-on-red: #40000f;
  --aui-accent-red-soft: #7c0026;
  --aui-accent-on-red-soft: #ffeced;
  --aui-accent-orange: #ffb690;
  --aui-accent-on-orange: #341100;
  --aui-accent-orange-soft: #632700;
  --aui-accent-on-orange-soft: #ffede6;
  --aui-accent-tennis: #d2fa46;
  --aui-accent-on-tennis: #171e00;
  --aui-accent-tennis-soft: #334000;
  --aui-accent-on-tennis-soft: #dcff66;
  --aui-accent-green: #65f2bc;
  --aui-accent-on-green: #002115;
  --aui-accent-green-soft: #004530;
  --aui-accent-on-green-soft: #bdffdf;
  --aui-accent-teal: #2fd9f4;
  --aui-accent-on-teal: #001f25;
  --aui-accent-teal-soft: #00424c;
  --aui-accent-on-teal-soft: #d4f7ff;
  --aui-accent-blue: #bac3ff;
  --aui-accent-on-blue: #001159;
  --aui-accent-blue-soft: #061e77;
  --aui-accent-on-blue-soft: #f0efff;
  --aui-accent-purple: #ddb7ff;
  --aui-accent-on-purple: #1c0334;
  --aui-accent-purple-soft: #410071;
  --aui-accent-on-purple-soft: #ddb7ff;
  --aui-fills-surface-contrast: #ffffff0a;
  --aui-fills-surface-contrast-inverse: #0c0e1114;
  --aui-fills-drop-shadow: #0c0e1126;
  --aui-fills-actions-pressed-shadow: #ffffff14;
  --aui-fills-cards-pressed-shadow: #0c0e110a;
  --aui-fills-sticker-opacity: 100%;
  --aui-gradient-dark-stop-1: #ca93ff;
  --aui-gradient-dark-stop-2: #f2aeff;
  --aui-gradient-light-stop-1: #370f5b;
  --aui-gradient-light-stop-2: #001a42;
}

.partner-light {
  --aui-brand-white: #ffffff;
  --aui-brand-black: #0c0e11;
  --aui-brand-asurion-purple: #8223d2;
  --aui-brand-asurion-yellow: #d2fa46;
  --aui-brand-asurion-blue: #4a68f9;
  --aui-brand-asurion-green: #6efac3;
  --aui-sub-surface: #f1f0f4;
  --aui-surface: #ffffff;
  --aui-surface-variant: #faf9fc;
  --aui-on-surface: #1a1c1e;
  --aui-on-surface-soft: #5d5e61;
  --aui-outline: #c6c6ca;
  --aui-outline-soft: #eeedf1;
  --aui-scrim-overlay: #0c0e1180;
  --aui-elevated-level-01: #ffffff;
  --aui-elevated-level-02: #ffffff;
  --aui-elevated-level-03: #ffffff;
  --aui-elevated-dynamic-card: #ffffff;
  --aui-primary: #0c0e11;
  --aui-on-primary: #ffffff;
  --aui-primary-soft: #f1f0f4;
  --aui-on-primary-soft: #3a3b3e;
  --aui-secondary: #e3e2e6;
  --aui-on-secondary: #1a1c1e;
  --aui-neutral: #1a1c1e;
  --aui-on-neutral: #ffffff;
  --aui-neutral-soft: #f1f0f4;
  --aui-on-neutral-soft: #2f3033;
  --aui-inverse-surface: #252629;
  --aui-inverse-on-surface: #ffffff;
  --aui-inverse-primary: #e3e2e6;
  --aui-status-success-soft: #c5ffc8;
  --aui-status-on-success-soft: #062011;
  --aui-status-success: #136d31;
  --aui-status-on-success: #c5ffc8;
  --aui-status-error-soft: #ffdad7;
  --aui-status-on-error-soft: #410004;
  --aui-status-error: #b91a24;
  --aui-status-on-error: #ffeae9;
  --aui-status-warning-soft: #fff0c0;
  --aui-status-on-warning-soft: #3a3000;
  --aui-status-warning: #e7c500;
  --aui-status-on-warning: #524609;
  --aui-accent-red: #b91641;
  --aui-accent-on-red: #fff8f7;
  --aui-accent-red-soft: #fff0f1;
  --aui-accent-on-red-soft: #67001e;
  --aui-accent-orange: #ec6a06;
  --aui-accent-on-orange: #fff8f6;
  --aui-accent-orange-soft: #fff1eb;
  --aui-accent-on-orange-soft: #552100;
  --aui-accent-tennis: #d2fa46;
  --aui-accent-on-tennis: #171e00;
  --aui-accent-tennis-soft: #e5ff8d;
  --aui-accent-on-tennis-soft: #293500;
  --aui-accent-green: #6efac3;
  --aui-accent-on-green: #002115;
  --aui-accent-green-soft: #ccffe5;
  --aui-accent-on-green-soft: #003826;
  --aui-accent-teal: #2fd9f4;
  --aui-accent-on-teal: #001f25;
  --aui-accent-teal-soft: #ddf9ff;
  --aui-accent-on-teal-soft: #00363e;
  --aui-accent-blue: #4a68f9;
  --aui-accent-on-blue: #fbf8ff;
  --aui-accent-blue-soft: #f4f2ff;
  --aui-accent-on-blue-soft: #00208d;
  --aui-accent-purple: #8223d2;
  --aui-accent-on-purple: #ffffff;
  --aui-accent-purple-soft: #faecff;
  --aui-accent-on-purple-soft: #590099;
  --aui-fills-surface-contrast: #0c0e110a;
  --aui-fills-surface-contrast-inverse: #ffffff14;
  --aui-fills-drop-shadow: #0c0e110a;
  --aui-fills-actions-pressed-shadow: #0c0e1114;
  --aui-fills-cards-pressed-shadow: #0c0e110a;
  --aui-fills-sticker-opacity: 0%;
  --aui-gradient-dark-stop-1: #6900b3;
  --aui-gradient-dark-stop-2: #991bbd;
  --aui-gradient-light-stop-1: #faecff;
  --aui-gradient-light-stop-2: #f0efff;
}

/* Component-specific tokens */
:root, .asurion-dark, .asurion-light, .partner-dark, .partner-light {
  --aui-action-outline-fill: var(--aui-fills-surface-contrast-inverse);
  --aui-action-border-radius: var(--aui-border-radius-round);
  --aui-tag-on-theme-alt: var(--aui-on-secondary);
  --aui-tag-theme-alt: var(--aui-secondary);
  --aui-action-inactive-toggle-stroke: var(--aui-outline-soft);
  --aui-action-inactive-toggle-surface: var(--aui-surface-variant);
  --aui-action-on-surface: var(--aui-on-surface);
  --aui-action-outline-action: var(--aui-on-surface);
  --aui-action-on-tonal-action: var(--aui-on-secondary);
  --aui-action-tonal-action: var(--aui-secondary);
  --aui-tag-on-theme: var(--aui-on-primary);
  --aui-action-on-filled-action: var(--aui-on-primary);
  --aui-tag-theme: var(--aui-primary);
  --aui-action-subtle-engaged: var(--aui-primary);
  --aui-action-filled-action: var(--aui-primary);
}
`;